
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "../ui/button";
import Navigation from "../Navigation";
import FortuneBackground from "../FortuneBackground";

interface PageLayoutProps {
  children: ReactNode;
  showBackButton?: boolean;
}

const PageLayout = ({ children, showBackButton = true }: PageLayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col p-8 pb-40 relative overflow-hidden">
      <FortuneBackground />

      <div className="max-w-4xl mx-auto w-full">
        <div className="flex flex-col">
          {/* Navigation moved to the top */}
          <Navigation />
          
          {/* Back button now comes after navigation */}
          {showBackButton && (
            <div className="mb-8 mt-4">
              <Link to="/">
                <Button variant="ghost" className="flex items-center gap-2 text-muted-foreground hover:text-foreground">
                  <ArrowLeft size={16} />
                  Back to Fortune
                </Button>
              </Link>
            </div>
          )}
        </div>

        {children}
      </div>
    </div>
  );
};

export default PageLayout;
